// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"3c2dea1b","44":"c0c12e9b","64":"4fe267a1","77":"a77b7378","103":"26b46fbd","241":"2338560f","315":"efd201ae","330":"a1b6f065","359":"50b53a6d","387":"ea847bea","638":"f7360856","650":"1d44106b","671":"5dc2e77e","682":"4aca92b3","719":"4987d7fc","965":"850ccd1d"}[chunkId] + ".chunk.js";
};